import { login, logout, getInfo, register, resetPassword, resetPasswordByEmail } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  infoLoaded: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_INFO_LOADED: (state, loaded) => {
    state.infoLoaded = loaded
  }
}

const actions = {
  // user register
  register({ commit }, userInfo) {
    const { email, emailCode, password, confirmPassword } = userInfo
    return new Promise((resolve, reject) => {
      register({
        password,
        confirmPassword,
        email,
        emailCode,
        portal: window?.SITE_CONFIG?.portal
      }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        commit('SET_INFO_LOADED', false)
        setToken('Bearer ' + data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetPassword({ commit }, userInfo) {
    const { oldPassword, newPassword } = userInfo
    return new Promise((resolve, reject) => {
      resetPassword({
        oldPassword,
        newPassword
      }).then(response => {
        const { data } = response
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetPasswordByEmail({ commit }, userInfo) {
    const { email, emailCode, newPassword } = userInfo
    return new Promise((resolve, reject) => {
      resetPasswordByEmail({
        email,
        emailCode,
        newPassword
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, captcha: '' }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        commit('SET_INFO_LOADED', false)
        setToken('Bearer ' + data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const permissions = Array.isArray(data.permissions) ? data.permissions : []
        const username = data.username || ''

        commit('SET_ROLES', permissions)
        commit('SET_NAME', username)
        commit('SET_INFO_LOADED', true)
        resolve(data)
      }).catch(error => {
        commit('SET_INFO_LOADED', false)
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_INFO_LOADED', false)
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_INFO_LOADED', false)
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
